import { Decoder, field, succeed } from 'jsonous';
import { resourceDecoder } from '../Resource/Decoders';
import { formTemplatesDecoder } from '../Resource/FormTemplates/Decoders';
import { GroupNewPayload, GroupNewResource } from './Types';

const groupNewPayloadDecoder: Decoder<GroupNewPayload> = succeed({});

export const groupNewResourceDecoder: Decoder<GroupNewResource> = resourceDecoder(
  groupNewPayloadDecoder,
).assign('templates', ({ links }) => field('templates', formTemplatesDecoder(links)));
